/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DownSavingStatementResponse = {
    downSavingId: string;
    referenceId?: string;
    startDate?: string;
    endDate?: string;
    customerName?: string;
    status: DownSavingStatementResponse.status;
    transactionId: string;
    transactionAt?: string;
    amount?: number;
    fineAmount?: number;
    direction: DownSavingStatementResponse.direction;
    shopPaymentChannelId?: string;
    createdByUser?: string;
};
export namespace DownSavingStatementResponse {
    export enum status {
        ACTIVE = 'ACTIVE',
        CLOSED = 'CLOSED',
        DATA_LOSS = 'DATA_LOSS',
        LINE_BLOCKED_DEVICE_RECEIVE = 'LINE_BLOCKED_DEVICE_RECEIVE',
        LINE_BLOCKED_DEVICE_NOT_RECEIVE = 'LINE_BLOCKED_DEVICE_NOT_RECEIVE',
        CANCELLED = 'CANCELLED',
        WITHDRAWN = 'WITHDRAWN',
    }
    export enum direction {
        DEPOSIT = 'DEPOSIT',
        WITHDRAW = 'WITHDRAW',
    }
}

